import * as React from "react"

const Upload = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      d="M12.5 13h-9M8 10V4m2.5 1.5L8 3 5.5 5.5"
      fill="none"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
  </svg>
)

export default Upload
